export const getPosPlanComponent = () => { 
    return {
      widgets:[ 
        {
          code:'19500',
          name: 'POSPLAN',
          bundleLink: null,
          bundleCode: null,
          group: 'POSPLAN',
          groupTitle: '',
          errorMessage: [],
          components:[
            {
              id:'idPOSPlan',
              name: 'PLAN',
              value: '',
              status: [''],
              errorMessage: [],
              //validations: {
               // isRequired: true,
                 //default: [
                //   {
                //     validate: VALIDATION_METHODS.filled,
                //     getErrorMessage:VALIDATION_ERRORS.filled
                //   }
                 //]
              //},
              //type: 'label',
              type: 'InfoTool',
              cleanName: 'PLAN',//'PromoCode',
              active:true,
              isDisabled:false
            }
          ],
          active:true,
          status:[]

        }
      ]
      
    }
  }


// WEBPACK FOOTER //
// ./state/static/posPlanStatic.js